import React, { Component } from "react";
import Loader from "react-loader-spinner";
import PropTypes from "prop-types";
import classnames from "classnames";
require("./load_mask_to.css");

class LoadMaskTO extends Component {
    static propTypes = {
        radius: PropTypes.bool,
        loading: PropTypes.bool.isRequired,
        dark: PropTypes.bool,
        blur: PropTypes.bool,
        light: PropTypes.bool
    };

    static defaultProps = {
        radius: false,
        dark: false,
        blur: false,
        light: false
    };

    render() {
        const { children, radius, dark, light, blur, loading } = this.props;

        return (
            <div className="load-mask">
                {loading && (
                    <div
                        className={classnames("loader-container d-flex flex-column", {
                            radius,
                            dark,
                            light
                        })}
                    >
                        <Loader
                            type={"Rings"}
                            color="#FFBE0B"
                            height="100"
                            width="100"
                        />
                        <p className="txt-loading">Cargando...</p>
                    </div>
                )}
                <div
                    className={classnames("load-mask-content", {
                        loading,
                        blur
                    })}
                >
                    {children}
                </div>
            </div>
        );
    }
}

export default LoadMaskTO;